// src/api/axiosInstance.ts
import axios from "axios"

import EnvVars from "../env-vars"

const axiosInstance = axios.create({
  baseURL: EnvVars.API_URL,
  timeout: 30000, // 30 seconds
  headers: {
    "Content-Type": `application/json`,
  },
})

axiosInstance.interceptors.request.use(
  (config) => {
    const jwt = localStorage.getItem(`jwt`)

    const token = jwt

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

export default axiosInstance
